import React, { memo } from "react";
import { COLORS } from "../config/themes";

const Badge = memo(({ children, color = COLORS.primary, bg = COLORS.primaryPale }) => (<span style={{ display: "inline-block", padding: "2px 10px", borderRadius: 20, fontSize: 11, fontWeight: 600, color, backgroundColor: bg, letterSpacing: 0.3, whiteSpace: "nowrap" }}>{children}</span>));

export default Badge;
